import React, { FunctionComponent } from 'react';

import {
  default as MuiListIcon,
  ListItemIconProps,
} from '@mui/material/ListItemIcon';

const ListItemIcon: FunctionComponent<ListItemIconProps> = ({
  sx,
  children,
}: ListItemIconProps) => {
  return <MuiListIcon sx={sx}>{children}</MuiListIcon>;
};

export default ListItemIcon;
